@import 'styles/variables';
@import 'styles/mixins';

.defaultIcon {
  stroke: $grey-40;
  fill: none;
}

.loadingEmoji {
  margin: 0;
  margin-right: 5px;
  padding: 1.5px;

  div::after {
    background: transparent;
  }
}

.emojiTrigger {
  @include ui-lg-text;

  padding: 0px !important;
  background: none;
  max-height: 32px;
  min-width: 16px;
  border-radius: 0px !important;
  min-height: 32px !important;
}

.emojiIcon {
  font-size: 16px;
  display: flex;
  align-items: center;
  justify-self: center;
  width: 16px;
  max-height: 16px;
}

.triggerWrap {
  display: flex;
  align-items: center;
  justify-content: center;
}

.folderIcon {
  margin-left: 0px;
  margin-right: 0px;
}
